import { CollapsableTableTrigger } from 'components/common-form/builder/form/node/field/DealSplit/CollapsableTable/CollapsableTable';
import { IndependentAmountField } from 'components/common-form/builder/form/node/field/DealSplit/IndependentAmountField/IndependentAmountField';
import type { DealSplitRowModel } from 'components/common-form/builder/form/node/field/DealSplit/types';
import {
  EMPTY_INDEPENDENT_AMOUNT,
  getIACurrency,
  hasIndependentAmountValues,
  hasOtherRowsWithIndependentAmount,
} from 'components/common-form/builder/form/node/field/DealSplit/utils';
import { useData } from 'components/common-form/hooks/useData';
import type { DealSplitIndependentAmount } from 'models/forms/DealSplitData';
import { FC } from 'react';

type Props = {
  dealSplits: DealSplitRowModel[];
  row: DealSplitRowModel;
  rowIndex: number;
  currency: string;
  isReadonly?: boolean;
  onRowIndependentAmountChanged?: (rowIndex: number, independentAmount?: DealSplitIndependentAmount) => void;
};

export const DealSplitIAMainCell: FC<Props> = ({
  dealSplits,
  row,
  rowIndex,
  currency,
  isReadonly,
  onRowIndependentAmountChanged,
}) => {
  const [iaCurrency] = useData<Nullable<string>>('Currency');
  const rowHasIndependentAmount = hasIndependentAmountValues(row.independentAmount);
  const currentIndependentAmount = row.independentAmount ?? EMPTY_INDEPENDENT_AMOUNT;

  return (
    <div className="d-flex align-items-center">
      <CollapsableTableTrigger>
        {({ isExpanded, setExpanded }) => (
          <IndependentAmountField
            independentAmount={currentIndependentAmount}
            currency={getIACurrency(currency, iaCurrency)}
            isDisabled={isReadonly}
            index={rowIndex}
            isChecked={rowHasIndependentAmount}
            isCollapsed={!isExpanded}
            onToggleSwitch={isChecked => {
              if (!onRowIndependentAmountChanged) {
                return;
              }

              if (isChecked) {
                setExpanded(true);
                onRowIndependentAmountChanged(rowIndex, {
                  Type: 'Percentage',
                  Value: undefined,
                  ValueDate: undefined,
                });
                return;
              }

              onRowIndependentAmountChanged(rowIndex, EMPTY_INDEPENDENT_AMOUNT);

              setExpanded(hasOtherRowsWithIndependentAmount(dealSplits, rowIndex));
            }}
            onIndependentAmountChanged={value => onRowIndependentAmountChanged?.(rowIndex, value)}
          />
        )}
      </CollapsableTableTrigger>
    </div>
  );
};
